import {
  AHPLUS_PRICE,
  AHPLUS_COMPLETE_PRICE,
  ESSENTIAL_PLAN_PATH,
  COMPLETE_PLAN_PATH,
} from "modules/storyblok/components/AhPlusPricingPlans/config";

import type { EcommerceEventNames } from "utils/tracking/utils.d";

export const CHOOSE_PRODUCT_ESSENTIAL = {
  event: "cta_click",
  label: "choose_essential",
  placement: "pricing_plans",
} as const;

export const CHOOSE_PRODUCT_COMPLETE = {
  event: "cta_click",
  label: "choose_complete",
  placement: "pricing_plans",
} as const;

export const ESSENTIAL_GA4_ECOMMERCE_EVENT = {
  event: "select_item" as EcommerceEventNames,
  item_list_name: "ahp_lp_item_list_name",
  items: [
    {
      item_id: "membership_essential_annual",
      item_name: "AirHelpPlus Membership",
      index: 1,
      item_brand: "AirHelp",
      item_category: "1YearMembership",
      item_category2: "Subscription",
      item_list_name: "ahp_lp_item_list_name",
      item_variant: "essential",
      price: 24.99,
      quantity: 1,
      affiliation: "",
      coupon: "",
      discount: "",
    },
  ],
}

export const COMPLETE_GA4_ECOMMERCE_EVENT = {
  event: "select_item" as EcommerceEventNames,
  item_list_name: "ahp_lp_item_list_name",
  items: [
    {
      item_id: "membership_complete_annual",
      item_name: "AirHelpPlus Membership",
      index: 2,
      item_brand: "AirHelp",
      item_category: "1YearMembership",
      item_category2: "Subscription",
      item_list_name: "ahp_lp_item_list_name",
      item_variant: "complete",
      price: 49.99,
      quantity: 1,
      affiliation: "",
      coupon: "",
      discount: "",
    },
  ],
}

export const usePricingPlanDetailsConfig = () => {
  const config = {
    essential: {
      planType: "essential",
      price: AHPLUS_PRICE,
      pricePerMonth: "€2.09",
      priceInfoText: "€24.99 per year",
      nameText: "Essential",
      buttonText: "button_choose_essential",
      buttonType: "primary",
      buttonPath: ESSENTIAL_PLAN_PATH,
      items: [
        {
          text: "We get you the money you’re entitled to from the airline:",
          textExtend: "- Up to $700 for compensation<br />- Up to $7,000 for extra expenses<br />- Up to $1,700 for luggage issues",
          popoverText: "Our experts will check what you’re eligible for under several air passenger laws. Any money we find you’re entitled to, our experts will work to claim for you from the airline.",
        },
        {
          text: "No hidden fees",
          popoverText: "AirHelp Plus members receive 100% of the compensation from the airline.",
        },
        {
          text: "24/7 support from our experts",
        },
        {
          text: "AirPayout insurance for 3 future trips",
          popoverText: "AirPayout insurance protects your first 3 trips and pays you €100 if your flight gets canceled or delayed — and that's on top of any compensation from the airline!",
        },
      ],
    },
    complete: {
      planType: "complete",
      price: AHPLUS_COMPLETE_PRICE,
      pricePerMonth: "€4.16",
      priceInfoText: "<s style=\"color:#ABBDD1\">€64.99</s> €49.99 per year",
      nameText: "Complete",
      buttonText: "button_choose_complete",
      buttonType: "primary",
      buttonPath: COMPLETE_PLAN_PATH,
      items: [
        {
          text: "All AirHelp Plus Essential benefits",
          highlighted: true,
        },
        {
          text: "Airport lounge access during a disruption",
          popoverText: "You receive a lounge pass when your flight is delayed over 1 hour or canceled 6 hours before departure. Valid at over 1,100 airport lounges worldwide for 3 months.",
        },
        {
          text: "AirPayout insurance for all your future trips",
          popoverText: "AirPayout insurance will protect a trip of your choice and pay you €100 if your flight gets canceled or delayed — that's on top of any compensation from the airline!",
        },
        {
          text: "AirLuggage insurance for all your future trips",
          popoverText: "AirLuggage is an easy insurance that protects you when it comes to luggage disruptions on future trips. You receive €150 for each checked-in bag that gets delayed or lost on arrival, up to a maximum of 4 bags. You’ll need a Property Irregularity Report (PIR) number from the lost luggage desk in the airport to be eligible.",
        },
      ],
    },
  };

  return config;
};
